import { smFunc } from '@/core/thinkhuge';

export class LotSizeCalculator {
  constructor() {
    // Fields for results
    this.resultsDiv = document.querySelector('.js-calculation-results-block');
    this.lotsizeNumberResult = document.querySelector('.js-lotsize-number');
    this.riskAmountResult = document.querySelector('.js-risk-amount');
    this.riskPercentResult = document.querySelector('.js-risk-percent');
    this.spinner = document.querySelector('.js-calculator-spinner');

    // Fields for calculations
    this.form = document.querySelector('.js-lot-calculator-form');
    this.pair = this.form.querySelector('.js-lot-calc-pair');
    this.depositCurrency = this.form.querySelector('.js-lot-calc-currency');
    this.entry = this.form.querySelector('.js-lot-calc-entry');
    this.stopLoss = this.form.querySelector('.js-lot-calc-stop-loss');
    this.calcMode = this.form.querySelector('.js-lot-calc-risk-tolerance');
    this.riskAmount = this.form.querySelector('.js-lot-calc-risk-amount');
    this.balance = this.form.querySelector('.js-lot-calc-balance');
    this.accountType = this.form.querySelector('.js-lot-calc-account-type');
    this.minLot = this.form.querySelector('.js-lot-calc-minimum-lot');
    this.calculateUrl = '/app/trading-tools/calculate-lot-size/';

    // Methods binding so we can call this.method
    this.showSpinning = this.showSpinning.bind(this);
    this.hideSpinning = this.hideSpinning.bind(this);
    this.fillResults = this.fillResults.bind(this);
    this.checkInput = this.checkInput.bind(this);
    this.calculate = this.calculate.bind(this);
  }

  showSpinning() {
    this.spinner.style.zIndex = 100;
    this.spinner.style.display = 'flex';
  }
  hideSpinning() {
    this.spinner.style.zIndex = -1;
    this.spinner.style.display = 'none';
  }
  fillResults(response) {
    this.lotsizeNumberResult.innerText = parseFloat(
      response.lot_size_position
    ).toFixed(2);
    let riskAmount =
      Math.round(parseFloat(response.risk_amt_in_deposit_currency) * 100) / 100;
    riskAmount = new Intl.NumberFormat().format(riskAmount);
    this.riskAmountResult.innerText = `${riskAmount} ${response.deposit_currency}`;
    this.riskPercentResult.innerText = `${parseFloat(
      response.risk_percent
    ).toFixed(1)} %`;
  }

  checkInput(element, stringOrNumber) {
    let value = element.value;
    if (stringOrNumber === 'number') {
      value = parseFloat(value);
    }
    if (value) {
      return value;
    } else {
      return 0;
    }
  }

  calculate() {
    this.showSpinning();
    //get current-pair value
    const currencyPair = this.checkInput(this.pair, 'string');
    const depositCurrency = this.checkInput(this.depositCurrency, 'string');
    const entryLevel = parseFloat(this.checkInput(this.entry, 'number'));
    const stopLevel = parseFloat(this.checkInput(this.stopLoss, 'number'));
    const calcMode = this.checkInput(this.calcMode, 'string');
    const riskAmount = parseFloat(this.checkInput(this.riskAmount, 'number'));
    const accountBalance = parseFloat(this.checkInput(this.balance, 'number'));
    const accountType = this.checkInput(this.accountType, 'string');
    const minLot = parseFloat(this.checkInput(this.minLot, 'number'));

    const allInputsAreValid =
      currencyPair &&
      depositCurrency &&
      accountType &&
      accountBalance &&
      entryLevel &&
      stopLevel &&
      minLot &&
      calcMode &&
      riskAmount;
    if (allInputsAreValid) {
      const body = {
        currencyPair: currencyPair,
        depositCurrency: depositCurrency,
        accountBalance: accountBalance,
        entryLevel: entryLevel,
        stopLevel: stopLevel,
        minLot: minLot,
        calcMode: calcMode,
        riskAmount: riskAmount,
        lotSize: accountType,
      };
      smFunc
        .getJson(this.calculateUrl, 'POST', body)
        .then((res) => {
          this.fillResults(res);
        })
        .finally(() => {
          this.resultsDiv.style.display = 'block';
          this.hideSpinning();
        });
    }
  }
}
